import { render, staticRenderFns } from "./referrals.vue?vue&type=template&id=54be1457&scoped=true&"
import script from "./referrals.vue?vue&type=script&lang=js&"
export * from "./referrals.vue?vue&type=script&lang=js&"
import style0 from "./referrals.vue?vue&type=style&index=0&id=54be1457&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be1457",
  null
  
)

export default component.exports